import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppHttpClient } from '@common/core/http/app-http-client.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ContactService {

private api = "https://mailthis.to/navin@jio.sh"

  constructor(
    private appHttp: AppHttpClient,
    private http: HttpClient
  ) {}

  PostMessage(input: any){
    return this.http.post(this.api, input, {responseType: 'text'}).pipe(
      map(
        (response)=>{
          if(response){
            return response;
          }
        },
        (error: any)=>{
          return error;
        }
      )
    )
  }

  generateZohoAccessToken(formData) {

    return this.appHttp.post('contact-us', formData).pipe(
      map(
        (response) => {
          console.log(response);
        },
        (error) => {
          console.log(error);
        }
      )
    )
  }
}
